import React from "react";
import { faTrophy, faStar } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ActiveSubmissionsCard from "./ActiveSubmissionsCard";

const UserSummaryCard = ({ user }) => {
  if (!user) return null;

  return (
    <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
      {/* Header with gradient */}
      <div className="bg-gradient-to-r from-deep-red to-bright-red p-4">
        <div>
          <h2 className="text-lg font-bold text-white mb-1">
            Welcome back, {user.username || user.name || "Fighter"}!
          </h2>
          <p className="text-white/80 text-sm">
            {new Date().toLocaleDateString("en-US", {
              weekday: "short",
              month: "short",
              day: "numeric",
            })}
          </p>
        </div>
      </div>

      {/* Stats row */}
      <div className="p-4 space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <div className="bg-gray-50 rounded-xl p-3 border border-gray-100">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 rounded-full bg-gold/10 flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faTrophy}
                  className="text-gold w-4 h-4"
                />
              </div>
              {user.globalRank && user.globalRank <= 10 && (
                <FontAwesomeIcon icon={faStar} className="text-gold w-4 h-4" />
              )}
            </div>
            <p className="text-xs text-medium-grey mb-1">Global Rank</p>
            <p className="text-lg font-bold text-dark-grey">
              {user.globalRank
                ? typeof user.globalRank === "object"
                  ? user.globalRank.name || "-"
                  : `#${user.globalRank}`
                : "-"}
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-3 border border-gray-100">
            <div className="flex items-center gap-2 mb-2">
              <div className="w-8 h-8 rounded-full bg-deep-red/10 flex items-center justify-center">
                <FontAwesomeIcon
                  icon={faTrophy}
                  className="text-deep-red w-4 h-4"
                />
              </div>
            </div>
            <p className="text-xs text-medium-grey mb-1">Active Leagues</p>
            <p className="text-lg font-bold text-dark-grey">
              {user.totalLeagues || 0}
            </p>
          </div>
        </div>

        {/* Active Submissions inline */}
        <ActiveSubmissionsCard embedded />
      </div>
    </div>
  );
};

export default UserSummaryCard;
